import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { KMenuElementPosition } from './index.props.js';

var PREFIX = "KMenuWidget";
var classes = {
    listOfLinks: "".concat(PREFIX, "-listOfLinks"),
    link: "".concat(PREFIX, "-link")
};
var StyledKMenuWidget = styled(Box, {
    shouldForwardProp: function (prop) {
        return prop !== "backgroundColor" &&
            prop !== "borderColor" &&
            prop !== "color" &&
            prop !== "menuColorOnHover" &&
            prop !== "linksPosition" &&
            prop !== "horizontalLinksPadding" &&
            prop !== "menuHeight" &&
            prop !== "linksSize";
    }
})(function (_a) {
    var _b;
    var backgroundColor = _a.backgroundColor, borderColor = _a.borderColor, color = _a.color, menuColorOnHover = _a.menuColorOnHover, linksPosition = _a.linksPosition, horizontalLinksPadding = _a.horizontalLinksPadding, menuHeight = _a.menuHeight, linksSize = _a.linksSize, theme = _a.theme;
    return (_b = {
            backgroundColor: backgroundColor || theme.palette.common.white,
            border: "1px solid ".concat(borderColor || theme.palette.divider)
        },
        _b["& .".concat(classes.listOfLinks)] = {
            listStyleType: "none",
            height: "100%",
            padding: 0,
            margin: 0,
            display: "flex",
            flexWrap: "wrap",
            flexDirection: "row",
            justifyContent: (linksPosition === null || linksPosition === void 0 ? void 0 : linksPosition.toUpperCase()) === KMenuElementPosition.RIGHT
                ? "flex-end"
                : (linksPosition === null || linksPosition === void 0 ? void 0 : linksPosition.toUpperCase()) === KMenuElementPosition.LEFT
                    ? "flex-start"
                    : "center",
            alignItems: (linksPosition === null || linksPosition === void 0 ? void 0 : linksPosition.toUpperCase()) === KMenuElementPosition.RIGHT
                ? "flex-end"
                : (linksPosition === null || linksPosition === void 0 ? void 0 : linksPosition.toUpperCase()) === KMenuElementPosition.LEFT
                    ? "flex-start"
                    : "flex-center"
        },
        _b["& .".concat(classes.link)] = {
            ":hover": {
                background: menuColorOnHover
            },
            paddingRight: horizontalLinksPadding || "1.5rem",
            paddingLeft: horizontalLinksPadding || "1.5rem",
            height: menuHeight || theme.spacing(6),
            display: "flex",
            alignItems: "center",
            textDecoration: "none",
            textDecorationColor: color || theme.palette.common.black,
            "& .linkLabel": {
                fontSize: linksSize || "1em",
                color: "".concat(color || theme.palette.common.black)
            }
        },
        _b);
});

export { classes, StyledKMenuWidget as default };
//# sourceMappingURL=index.styled.js.map
